/* RESPONSIBLE TEAM: team-proactive-support */
import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default class SurveySerializer extends EmbercomBaseSerializer.extend(EmbeddedRecordsMixin) {
  attrs = {
    steps: { embedded: 'always' },
    senderId: { embedded: 'always' },
    senderType: { embedded: 'always' },
    paths: { embedded: 'always' },
    deletedQuestions: { embedded: 'always' },
  };
}
